import { type FC } from 'react'
import { observer } from 'mobx-react-lite'
import { Button } from 'shared/ui'
import { getAriaLabel } from 'shared/lib'
import { type GetNumberModalStore } from 'entities/Phone/ui/GetNumberModal/store/GetNumberModalStore'
import styles from './styles.module.scss'

type IGetNumberModalActionsProps = {
  store: GetNumberModalStore
}

export const GetNumberModalActions: FC<IGetNumberModalActionsProps> = observer(({ store }) => {
  const { chooseNumberStore, loadingNumber, handleAddNumber, closeModal } = store

  return (
    <div className={styles.actionsWrap} aria-label={getAriaLabel('GetNumberModalActions')}>
      <Button text='Cancel' contained='tertiary' onClick={closeModal} />
      <Button
        disabled={!chooseNumberStore.selectedNumber || loadingNumber}
        loading={loadingNumber}
        fullWidth
        typeBtn={'contained'}
        text={'Confirm number'}
        onClick={() => {
          handleAddNumber()
        }}
      />
    </div>
  )
})
